import React, { KeyboardEvent, useContext, useEffect, useState } from "react";
import { Button, Container, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";
import NavItem from "./NavItem";
import {
  APPLICATION_SEARCH,
  CHAT_BOOKING,
  EMPLOYEE_PORTAL,
  HOMEPAGE,
  JOBS,
  LOGOUT,
  SERVICES,
  TECHNOLOGIES
} from "../Routes";
import AuthContext from "../../Contexts/authContext";
import { AUTH_STATUS } from "../../Graphql/types/auth";
import Flyover from "../Common/Flyover/Flyover";

const navItems = [
  { label: "Home", route: "/" },
  { label: "Job Management", route: JOBS },
  { label: "Application Management", route: APPLICATION_SEARCH },
  { label: "Employee Management", route: EMPLOYEE_PORTAL },
  { label: "Technologies Management", route: TECHNOLOGIES },
  { label: "Services Management", route: SERVICES },
  { label: "Chat Booking", route: CHAT_BOOKING }
];

const Navigation = () => {
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate(HOMEPAGE);
  };
  const { authContextInfo } = useContext(AuthContext);
  const { info } = authContextInfo;
  const [showFlyOver, setShowFlyOver] = useState<boolean>(false);
  const [isLogged, setIsLogged] = useState(
    authContextInfo.auth.status === AUTH_STATUS.AUTHENTICATED
  );

  useEffect(() => {
    setIsLogged(authContextInfo.auth.status === AUTH_STATUS.AUTHENTICATED);
  }, [authContextInfo.auth.status]);

  return (
    <Stack
      style={{
        display: "flex",
        flexDirection: "row",
        gap: 2,
        alignItems: "center",
        boxSizing: "border-box",
        position: "sticky",
        background: "#fffafa",
        padding: "1em 2em",
        justifyContent: "space-between",
        width: "100%",
        zIndex: "99998989"
      }}
    >
      <Stack
        style={{
          display: "flex",
          width: "100px"
        }}
        onClick={handleButtonClick}
        onKeyDown={(event: KeyboardEvent<HTMLDivElement>) => {
          if (event.key === "Enter") {
            handleButtonClick();
          }
        }}
      >
        <img
          width="120px"
          src="https://kivunova.s3.us-east-1.amazonaws.com/kivu-nova-dark.png"
          alt="kivunova logo"
        />
      </Stack>
      {isLogged && (
        <Stack
          alignSelf="right"
          onClick={() => {
            setShowFlyOver(!showFlyOver);
          }}
          gap={1}
          flexDirection="row"
          justifyContent="center"
          alignItems="center"
        >
          <Stack width="30px" height="30px">
            <img
              src={info?.hiredEmployeeInfo?.avatar || ""}
              alt={info.firstName}
              width="100%"
              height="100%"
              style={{ borderRadius: "15px" }}
            />
          </Stack>
          <MenuIcon />
        </Stack>
      )}

      {isLogged && (
        <Flyover
          isOpen={showFlyOver}
          closeMenu={() => {
            setShowFlyOver(!showFlyOver);
          }}
        >
          <Stack
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              boxSizing: "border-box",
              width: "100%"
            }}
          >
            {navItems.map((nav) => (
              <NavItem
                clickHandler={() => setShowFlyOver(false)}
                key={nav.label}
                routeUrl={nav.route}
                title={nav.label}
              />
            ))}
            <Container
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "row",
                marginTop: "2em"
              }}
            >
              <Button
                onClick={() => navigate(LOGOUT)}
                variant="outlined"
                endIcon={<LogoutIcon />}
              >
                Logout
              </Button>
            </Container>
          </Stack>
        </Flyover>
      )}
    </Stack>
  );
};

export default Navigation;
